import React, {CSSProperties, ReactElement} from 'react';
import classNames from "classnames";


import {IconProps} from "../icons";
import {ButtonProps} from "../Button";
import {ContextMenuItem, ContextMenuItemProps} from "./ContextMenuItem";


import './ContextMenu.css';


export type ContextItemParams = Omit<ContextMenuItemProps, 'handleClose'>;

export interface ContextMenuProps {
    handleClose: () => void;
    items: ContextItemParams[];
    isDark?: boolean;
    isWide?: boolean;
    title?: string;
    subTitle?: string;
    SubTitleIcon?: React.ComponentType<IconProps>;
    className?: string
    button?: ReactElement<ButtonProps>,
    maxHeight?: number;
}

export const ContextMenu = (
    {
        handleClose,
        items,
        isDark,
        isWide,
        title,
        subTitle,
        SubTitleIcon,
        button,
        maxHeight
    }: ContextMenuProps
) => {
    const style: CSSProperties = {};

    if (maxHeight) {
        style.maxHeight = maxHeight;
    }

    const hasIcon = items.some(item => item.Icon !== undefined);
    return (
        <div
            style={style}
            className={
                classNames({
                    'ContextMenu body-large': true,
                    'ContextMenuWithTitle': title,
                    'ContextMenu__withIcon': hasIcon,
                    'ContextMenu--wide': isWide,
                    'theme-dark': isDark,
                })
            }>
            {
                title && (
                    <div className="title-large-bold ContextMenu__title">
                        {title}
                    </div>
                )
            }
            {
                subTitle && (
                    <div className="ContextMenu__subTitle">
                        {SubTitleIcon && (
                            <SubTitleIcon
                                className="ContextMenu__subTitleIcon"
                                size={16}/>
                        )}
                        <div className="ContextMenu__subTitleText body-medium"> {subTitle} </div>
                    </div>
                )
            }
            {
                items.filter(contextMenuItem => contextMenuItem.condition === undefined || contextMenuItem.condition)
                    .map((contextMenuItem, i) => (
                        <ContextMenuItem
                            key={i}
                            className={contextMenuItem.className}
                            text={contextMenuItem.text}
                            Icon={contextMenuItem.Icon}
                            ActionIcon={contextMenuItem.ActionIcon}
                            action={contextMenuItem.action}
                            onClick={contextMenuItem.onClick}
                            handleClose={handleClose}
                        />
                    ))
            }

            {
                button && (
                    <div className="Context-Menu__button">
                        {button}
                    </div>
                )
            }
        </div>
    )
}
